import { scalingPx } from 'util/css';
import { Box } from '@mui/material';
import React, { ReactElement, ReactNode } from 'react';

import { BackButton, Header } from '../../components/ui';

export interface SimpleActionLayoutProps {
  backLink?: string | (() => void) | null;
  children?: ReactNode;
}

export const SimpleActionLayout = ({
  backLink,
  children,
}: SimpleActionLayoutProps): ReactElement => {
  return (
    <>
      <Box
        width="100vw"
        minHeight="100%"
        style={{ background: '#fff' }}
        position="relative"
        pb={80}
      >
        <Header showActions={false} showSearch={false} />
        <Box pt={31} px={{ xs: 24, md: scalingPx(32, 60) }}>
          {backLink && (
            <Box display={{ xs: 'none', sm: 'flex' }} position="fixed">
              {typeof backLink === 'string' ? (
                <BackButton href={backLink} variant="filled" />
              ) : (
                <BackButton onClick={backLink} variant="filled" />
              )}
            </Box>
          )}
          <Box
            mt={{ xs: backLink ? 26 : 0, md: 0 }}
            width="100%"
            height="100%"
            display="flex"
            justifyContent="center"
          >
            {children}
          </Box>
        </Box>
      </Box>
    </>
  );
};
